import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import {
  ChartsGrid,
  ChartsLegend,
  ChartsXAxis,
  ChartsYAxis,
  lineElementClasses,
  LinePlot,
  markElementClasses,
  MarkPlot,
} from "@mui/x-charts";

import { Box } from "@mui/system";
import { LineChartPro } from "@mui/x-charts-pro";
import { CustomItemTooltipPercentage } from "../../../../../../ResuableChartTooltip/CustomItemTooltipPercentage";
import { useSelector } from "react-redux";
interface TrendDialogueProps {
  openRealUsers: boolean;
  onCloseRealUsers: () => void;
  GraphRealUsers: any;
  GraphPageSpecificRealUsers: any;
}

export const RealUsersTrendDialog = ({
  openRealUsers,
  onCloseRealUsers,
  GraphRealUsers,
  GraphPageSpecificRealUsers,
}: TrendDialogueProps) => {
  const { selectedPage } = useSelector(
    (state: any) => state.pageSpeedPerformance
  );
  return (
    <>
      <Dialog
        fullWidth
        maxWidth="lg"
        open={openRealUsers}
        onClose={onCloseRealUsers}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Box>
          <DialogTitle id="alert-dialog-title">
            {"Real Users’ Experience Trend"}
          </DialogTitle>
          <DialogContent>
            <LineChartPro
              dataset={
                selectedPage ? GraphPageSpecificRealUsers : GraphRealUsers
              }
              series={[
                {
                  type: "line",
                  dataKey: "y",
                  color: "#EE6002",
                  showMark: true,
                  curve: "linear",
                },
              ]}
              xAxis={[{ scaleType: "point", dataKey: "x", disableLine: true }]}
              yAxis={[
                {
                  dataKey: "y",
                  disableLine: true,
                  disableTicks: true,
                  position: "right",
                },
              ]}
              height={350}
              margin={{ left: 35, right: 50, top: 25, bottom: 30 }}
              sx={{
                [`& .${lineElementClasses.root}`]: {
                  strokeWidth: 2,
                },
                [`& .${markElementClasses.root}`]: {
                  scale: "0.6",
                  strokeWidth: 2,
                  "&:hover": {
                    scale: "1.2",
                    strokeWidth: 5,
                    opacity: "0.6",
                  },
                },
              }}
              leftAxis={null}
              rightAxis={{}}
            >
              <ChartsGrid horizontal />
              <CustomItemTooltipPercentage />
              <ChartsXAxis />
              <ChartsYAxis />
              <LinePlot />
              <MarkPlot />
              <ChartsLegend direction="row" />
            </LineChartPro>
          </DialogContent>
          <DialogActions sx={{ mx: "1rem", mb: "1rem" }}>
            <Button
              onClick={onCloseRealUsers}
              size="small"
              variant="contained"
              color="secondary"
            >
              Close
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  );
};
